module.exports = __webpack_public_path__ + "static/IMG_4928-b727449369dc2a1c98d5abbb12e76a85.jpg";